// REACT
import React, { useEffect, useState } from "react";

// REDUX
import { useDispatch, useSelector } from "react-redux";

// REACT ROUTER
import { useNavigate } from "react-router-dom";

// INTERNATIONALIZATION
import { useIntl } from "react-intl";

// STORE ACTIONS
import { addApplication } from "store/actions";

// COMPONENTS
import Loader from "components/shared/loader";
import SaveChangesButton from "components/Form/save-changes-button";
import FormWrapper from "components/Form/form-wrapper";
import Form from "components/Form";
import Input from "components/Form/input";
import Textarea from "components/Form/textarea/index";
import ImageUpload from "components/Form/image-upload";

// HELPERS
import { toastErrorMessage } from "helpers/toaster/toastErrorMessage";
import { handleErrMsg } from "helpers/functions";

// STYLES
import styles from "./styles/style.module.scss";
import { validateUrl } from "helpers/functions";

const AddApplication = () => {
    const { formatMessage, locale } = useIntl();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { loading, error } = useSelector((state) => state.applications);
    const [editAppInfoCheck, setEditAppInfoCheck] = useState(false);

    useEffect(() => {
        if (Object.keys(error)?.length > 0) {
            toastErrorMessage(
                formatMessage({ id: handleErrMsg(error) }),
                locale
            );
        }
    }, [error, formatMessage, locale, navigate]);

    const onSubmitDetails = (data) => {
        dispatch(addApplication({ data, navigate }));
        setEditAppInfoCheck(!editAppInfoCheck);
    };

    if (loading) return <Loader />;
    return (
        <div className={styles["add-application"]}>
            <FormWrapper title={"addApplication"}>
                <Form onSubmit={onSubmitDetails}>
                    <ImageUpload
                        name="icon"
                        langId={false}
                        rules={{
                            required: formatMessage({ id: "requiredField" }),
                        }}
                    />
                    <Input
                        name="name"
                        locale="ar"
                        langId="name"
                        rules={{
                            required: formatMessage({ id: "requiredField" }),
                        }}
                    />
                    <Input
                        name="name"
                        locale="en"
                        langId="name"
                        rules={{
                            required: formatMessage({ id: "requiredField" }),
                        }}
                    />

                    <Textarea
                        name="description"
                        locale="ar"
                        langId="description"
                        rules={{
                            required: formatMessage({ id: "requiredField" }),
                        }}
                    />
                    <Textarea
                        name="description"
                        locale="en"
                        langId="description"
                        rules={{
                            required: formatMessage({ id: "requiredField" }),
                        }}
                    />

                    <Input
                        name="website"
                        langId="appLink"
                        rules={{
                            required: formatMessage({ id: "requiredField" }),
                            validate: (value) =>
                                validateUrl(value) ||
                                formatMessage({ id: "invalidUrl" }),
                        }}
                    />
                    <Input
                        name="supportEmail"
                        langId="supportEmail"
                        rules={{
                            required: formatMessage({ id: "requiredField" }),
                            pattern: {
                                value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                                message: formatMessage({ id: "invalidEmail" }),
                            },
                        }}
                    />

                    <SaveChangesButton />
                </Form>
            </FormWrapper>
        </div>
    );
};

export default AddApplication;
